export interface ComparisonAgent {
  name: string;
  logo: string;
  pros: string[];
  cons: string[];
  rating: number;
  bestFor: string;
}

export const comparisonAgents: ComparisonAgent[] = [
  {
    name: 'CSSBuy',
    logo: 'CSS',
    pros: ['Largest spreadsheet community', 'Competitive service fees', 'Excellent QC photo system', 'Fast order processing', 'Multiple shipping lines'],
    cons: ['Website UI can be improved', 'Customer support response varies'],
    rating: 4.5,
    bestFor: 'Overall best choice for spreadsheet shopping',
  },
  {
    name: 'Superbuy',
    logo: 'SB',
    pros: ['Polished user interface', 'Good mobile app', 'Reliable shipping', 'Established reputation'],
    cons: ['Higher service fees', 'Smaller spreadsheet community'],
    rating: 4.2,
    bestFor: 'Beginners who value polished UX',
  },
  {
    name: 'Kakobuy',
    logo: 'KB',
    pros: ['Competitive pricing', 'Growing spreadsheet network', 'Fast warehouse processing'],
    cons: ['Smaller community', 'Fewer shipping line options'],
    rating: 4.0,
    bestFor: 'Budget-conscious spreadsheet shoppers',
  },
  {
    name: 'Oopbuy',
    logo: 'OB',
    pros: ['Lowest service fees (3-5%)', 'Modern platform technology', 'Fast-growing seller network', 'Clean intuitive interface'],
    cons: ['Newest platform', 'Limited shipping carriers', 'Smaller seller network'],
    rating: 3.9,
    bestFor: 'Value-focused shoppers willing to try a newer platform',
  },
  {
    name: 'Sugargoo',
    logo: 'SG',
    pros: ['Good for budget hauls', 'Decent QC photos', 'Active community'],
    cons: ['Slower processing times', 'Limited premium shipping'],
    rating: 3.8,
    bestFor: 'Large budget hauls',
  },
];